const comparePrice = require('./services/price');
const compareScreen = require('./services/screen');
const compareTracking = require('./services/tracking');
const compareHardware = require('./services/hardware');

const compare = (items) => {
  const defaultItem = { ...items[0] };
  items.shift();
  return items.reduce(
    (acc, item) => ({
      price: [...comparePrice(acc.price[acc.price.length - 1], item)],
      screen: [...compareScreen(acc.screen[acc.screen.length - 1], item)],
      tracking: [...compareTracking(acc.tracking[acc.tracking.length - 1], item)],
      hardware: [...compareHardware(acc.hardware[acc.hardware.length - 1], item)],
    }),
    {
      price: [defaultItem],
      screen: [defaultItem],
      tracking: [defaultItem],
      hardware: [defaultItem],
    },
  );
};

module.exports = compare;
